import React, { useEffect, useState } from "react";
import { Container, Typography, Grid, Box } from "@mui/material";
import HomeCard from "../Component/HomeCard/HomeCard";
import VideoCorousel from "../Component/VideoCorousel/VideoCorousel";
import axios from "axios";

export default function CustomHomes() {
  const [customHomes, setCustomHomes] = useState([]);

  useEffect(() => {
    const fetchCustomHomes = async () => {
      try {
        const response = await axios.get(
          `https://urbancasabackendfiles.onrender.com/api/innerProjects?category=CustomHome`
        );
        setCustomHomes(response.data);
      } catch (error) {
        console.error("Error fetching custom homes:", error);
      }
    };

    fetchCustomHomes();
  }, []);

  return (
    <div>
      <VideoCorousel />
      <Container maxWidth="80%" style={{ padding: "40px" }}>
        <Typography variant="h3" align="center" gutterBottom>
          Custom Home Designs
        </Typography>

        <Box display="flex" justifyContent="center" flexWrap="wrap" gap="2vw">
          {customHomes.map((home) => (
            <Box key={home._id} sx={{ width: { xs: "100%", sm: "45%", md: "30%" } }}>
              <HomeCard home={home} />
            </Box>
          ))}
        </Box>
      </Container>
    </div>
  );
}
